const deniedKeys = ["forwarded", "-ip", "remote-", "via", "-user"];

// Preserve Sentry v10 collection defaults when upgrading to v11.
export const sentryDataCollection = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: { deny: deniedKeys },
    response: { deny: deniedKeys },
  },
  httpBodies: [],
  urlQueryParams: { deny: deniedKeys },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  graphQL: { document: false, variables: false },
  queues: false,
  frameContextLines: 7,
};
